module.exports = __webpack_public_path__ + "img/Carvisor - Online car valuation platform and analytics.bf1c632f.jpg";